const MapActionTypes = {
  SET_CONFIG: "map/SET_CONFIG",
  SET_CONFIG_PARAM: "map/SET_CONFIG_PARAM",
  SET_INITIALIZED: "map/SET_INITIALIZED",
};

export default MapActionTypes;
